module.exports = __webpack_public_path__ + "static/media/contract.80b6ba99.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/contract.png
// module id = 77
// module chunks = 29